<template>
  <div>
    <b-list-group>
      <b-list-group-item v-for="item in navlist" :key="item.index">
        <b-link :to="item.link">{{item.title}}</b-link>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navlist: [
          {
              title: "Contacts",
              link: "/contacts"
          },
          {
              title: "Cookie Policy",
              link: "/contacts/cookie"
          },
          {
              title: "Privacy Policy",
              link: "/contacts/privacy"
          },
          {
              title: "Terms and Conditions",
              link: "/contacts/terms"
          }
        ]
    };
  }
};
</script>

<style lang="scss" scoped>
.list-group {
  margin-bottom: 40px;
  .list-group-item {
    padding: 0;
    a {
      color: #434343;
      text-decoration: none;
      padding: 12px 20px;
      display: block;
    }
    .router-link-exact-active {
      background: $base-blue-nav;
      color: #fff;
    }
  }
  .list-group-item.active {
    a {
      color: #fff;
    }
  }
}
</style>